// extracted by mini-css-extract-plugin
export default {"card":"card_card__4E9+K"};